<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Manage"></side-menu>


    <div class="content">
        <div class="dashboard">
        <heading  :title="'Manage'"></heading>

        </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import Upload from "@/components/Upload.vue";
import Popup from "@/components/Popup.vue";

import { Datetime } from "vue-datetime";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");
export default {
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    datetime: Datetime,
    heading: Title,
    popup: Popup,
    upload: Upload
  },
  data() {
    return {};
  }
};
</script>

<style>
</style>